import React from "react";
import "./CompanyList.css";
// import { useSelector } from "react-redux";
import { Accordion, Button, Card } from "react-bootstrap";
// import CompanyCrewListCard from "./CompanyCrewListCard";
import { BlackWhite } from "./styledComponents/colors";
import { translate } from "./Language/Translate";
import UserList from "./CompanyUserList";
// import {Button}


const CompanyUsers = ({eventKey}) => {


    return(
    
        <Card key={eventKey}>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey={eventKey}>
            <BlackWhite>{translate('Users')}</BlackWhite>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey={eventKey}>
            <Card.Body>
                <UserList/>
            </Card.Body>
        </Accordion.Collapse>
        </Card>
    )
};
export default CompanyUsers;